import React, { useEffect, useState } from "react";
import EditAdminForm from "../../components/adminForm/EditAdminForm";
import AddAdminForm from "../../components/adminForm/AddAdminForm";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";

const Admins = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [admins, setAdmins] = useState(null);
  const [isLoader, setIsLoader] = useState(false);

  const [admin, setAdmin] = useState({});

  const getViewAdmins = async () => {
    try {
      if (admins[activeIndex]._id) {
        const response = null;
        if (response) {
          setAdmin(response);
        }
      }
    } catch (error) {}
  };

  const handleIconClick = (index) => {
    if (index === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const getAllAdmins = async () => {
    try {
      const response = null;
      if (response) {
        setAdmins(response);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const deleteAdmin = async () => {
    try {
      if (window.confirm("Are you sure ? You want to Delete admin ??")) {
        const response = null;
        if (response) {
          toast.success("Admin deleted");
          getAllAdmins();
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    getAllAdmins();
  }, []);

  useEffect(() => {
    getViewAdmins();
  }, [activeIndex]);

  return (
    <div className="container">
      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
          <ion-icon name="people-outline"></ion-icon>
          <span className="text">Admin</span>
        </div>

        <button
          className="btn-header d-flex align-items-center gap-1"
          data-bs-target="#addAdminsModal"
          data-bs-toggle="modal"
        >
          <ion-icon name="add-outline"></ion-icon>
          Add
        </button>
      </div>

      <div className="data-table activityTable">
        <div className="tableStyle">
          <table>
            <thead>
              <tr>
                <th className="admin-name-th">No</th>
                <th className="admin-th">Name</th>
                <th className="admin-email-th">Email</th>
                {/* <th className="admin-th">Phone Number</th> */}
                <th className="admin-th">Role</th>
                <th style={{ width: "10%" }} className="admin-th">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {admins?.map((admin, index) => (
                <tr>
                  <td className="admin-name-td" key={index}>
                    {index + 1}
                  </td>
                  <td className="admin-td ">
                    <div className="">{admin.name}</div>
                  </td>
                  <td className="admin-email-th">{admin.email}</td>
                  {/* <td className="admin-td">{admin.phoneNumber}</td> */}
                  <td className="admin-td">{admin.role}</td>
                  <td className="admin-td">
                    <ion-icon
                      name="ellipsis-vertical-outline"
                      id="userAction"
                      onClick={() => handleIconClick(index)}
                      style={{ cursor: "pointer" }}
                    ></ion-icon>
                    {activeIndex === index && (
                      <div className="showOption">
                        <NavLink
                          to={`/view-admin/${admin._id}`}
                          style={{ textDecoration: "none" }}
                        >
                          <p className="pt-3 d-flex align-items-center gap-2">
                            <ion-icon name="eye-outline"></ion-icon> View
                          </p>
                        </NavLink>

                        <p
                          className="d-flex align-items-center gap-2 actionItems"
                          data-bs-target="#editAdminsModal"
                          data-bs-toggle="modal"
                        >
                          <ion-icon name="create-outline"></ion-icon> Edit
                        </p>
                        <p
                          onClick={deleteAdmin}
                          className="d-flex align-items-center gap-2 cursor-pointer"
                          style={{ color: "red", cursor: "pointer" }}
                        >
                          <ion-icon name="trash-outline"></ion-icon> Delete
                        </p>
                        {/* <p className="d-flex align-items-center gap-2 cursor-pointer">
                          <ion-icon name="ban-outline"></ion-icon>Deactivate
                        </p> */}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Edit Admin */}
          <div>
            <EditAdminForm admin={admin} getAdmins={getAllAdmins} />
          </div>
          {/* Add Admin */}
          <div>
            <AddAdminForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admins;
